import { AlertCircle, Check } from "lucide-react";

export default function FormFieldStatus({
  loading,
  loadingMessage,
  success,
  successMessage,
  error,
  errorMessage,
}: {
  loading: boolean;
  loadingMessage?: string;
  success: boolean;
  successMessage?: string;
  error: boolean;
  errorMessage?: string;
}) {
  if (loading) {
    return (
      <div className="mt-1">
        <div className="text-sm flex flex-row gap-1.5 items-center">
          <p className="text-gray-600">{loadingMessage || "Updating..."}</p>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="mt-1">
        <div className="text-sm flex flex-row gap-1.5 items-center">
          <Check className="w-4 h-4 text-green-600" />
          <p className="text-green-600">
            {successMessage || "Updated successfully!"}
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mt-1">
        <div className="text-sm flex flex-row gap-1.5 items-center">
          <AlertCircle className="w-4 h-4 text-red-600" />
          <p className="text-red-600">{errorMessage || "An error occurred"}</p>
        </div>
      </div>
    );
  }

  return null;
}
